import { Component, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';
import {
  CdkDragDrop,
  moveItemInArray,
  transferArrayItem,
  CdkDrag,
  CdkDropList,
  CdkDropListGroup,
  CdkDragMove,
} from '@angular/cdk/drag-drop';
import { ViewportRuler } from '@angular/cdk/scrolling';
import { link } from 'fs';
import { StoreInfoService } from 'src/app/store-info.service';

type ListingViewMode = 'tile' | 'list';

@Component({
  selector: 'app-menu-manager',
  templateUrl: './menu-manager.component.html',
  styleUrls: ['./menu-manager.component.scss'],
})
export class MenuManagerComponent implements OnInit {
  @ViewChild(CdkDropListGroup) listGroup: CdkDropListGroup<CdkDropList>;
  @ViewChild(CdkDropList) placeholder: CdkDropList;
  public target: CdkDropList;
  public targetIndex: number;
  public source: CdkDropList;
  public sourceIndex: number;
  public dragIndex: number;
  public activeContainer;

  bearer;
  store_id;

  loading = true;
  modalLoading = true;
  closeResult = '';
  success = 'success';

  menuList = [];
  menuName = '';
  menuLink = '';
  menuDesc = '';
  menuCountry = '';
  menuLanguage = '';
  storeMenuId = '';
  menuForm: FormGroup;
  storeUrl = '';
  previewToken = '';
  pageList;
  filterPageList;
  externalDisplay: boolean = true;
  external;
  currentSelectUrl = '';
  currentExternalSelectUrl = '';
  visibility;
  displayedMenuList = [];
  body;

  public initialArrangement = [];
  public menuArrangement = [];
  customArrangementReady = false;
  isSavingArrangement = false;
  filteredString = '';
  menuType;
  checked;
  unchecked;
  externalLink;
  pageTitle;
  urlType;
  radioDisable;

  listingView: ListingViewMode = 'list';
  storeInfo$ = this.storeInfoService.getStoreInfos();

  buildCreateForm() {
    this.menuForm = this.formBuilder.group({
      menu_name: [''],
      menu_link: [''],
      menu_desc: [''],
      menu_country: ['ALL'],
      menu_language: ['ALL'],
    });
  }

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    public utils: UtilitiesService,
    private formBuilder: FormBuilder,
    private router: Router,
    private viewportRuler: ViewportRuler,
    private storeInfoService: StoreInfoService
  ) {
    this.target = null;
    this.source = null;
  }

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    this.getStoreInfo();

    this.buildCreateForm();

    this.fetchMenuList();

    this.fetchLanguage();
    this.fetchCountry();
  }

  getStoreInfo() {
    this.storeInfo$.subscribe((res) => {
      this.storeUrl = res.store_url;
    });
  }

  removeUrl() {
    this.menuForm.get('menu_link').setValue('');
    this.radioDisable = false;
    this.checked = true;
    this.urlType = true;
  }

  inputTouch() {
    let menuLinkname;
    menuLinkname = this.menuForm.get('menu_link').value;
    if (
      menuLinkname != '' ||
      (menuLinkname != undefined && menuLinkname != this.pageTitle)
    ) {
      this.urlType = true;
    }
    if (menuLinkname === this.pageTitle) {
      this.urlType = false;
    }
    // this.filterPageList.filter((item) => item.visibility != '0');
    if (this.filterPageList.length <= 8) {
      const element = <HTMLElement>(
        document.getElementsByClassName('custom-dropdown')[0]
      );
      element.style.height = 'unset';
    }
  }

  modalType = '';
  showCreateModal(modelRef) {
    this.buildCreateForm();
    this.modalType = 'CREATE';

    this.menuType = 2;
    this.visibility = 1;
    this.urlType = true;
    this.checked = true;
    this.unchecked = false;
    this.radioDisable = false;
    this.modalService
      .open(modelRef, {
        size: 'md',
        centered: true,
        backdrop: 'static',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.currentSelectUrl = '';
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  menuCreate() {
    this.menuName = this.menuForm.get('menu_name').value;
    this.menuLink = this.menuForm.get('menu_link').value;
    this.menuDesc = this.menuForm.get('menu_desc').value;
    this.menuCountry = this.menuForm.get('menu_country').value;
    this.menuLanguage = this.menuForm.get('menu_language').value;
    this.checked = true;
    this.modalLoading = true;
    if (this.menuLink != this.pageTitle) {
      this.external = 1;
      this.currentSelectUrl = this.menuLink;
    } else {
      this.external = 0;
      this.currentSelectUrl = this.currentExternalSelectUrl;
    }
    let body = {
      store_id: this.store_id,
      menu_name: this.menuName,
      menu_link: this.currentSelectUrl,
      visibility: this.visibility,
      external: this.external,
      menu_desc: this.menuDesc,
      language_code: this.menuLanguage,
      country_code: this.menuCountry,
    };
    this.svc.postMenuCreate(this.bearer, body).subscribe(
      (res) => {
        setTimeout(() => {
          this.modalLoading = false;
          this.utils.notify.showSuccess(
            this.utils.translate('New menu item has been added!')
          );

          this.modalService.dismissAll();
          this.reloadMenuList();
        }, 3000);
      },
      (error) => {
        console.log(error);
        if (
          this.menuName === undefined ||
          this.menuName === '' ||
          this.menuLink === '' ||
          this.menuLink === undefined
        ) {
          this.utils.notify.showError(
            this.utils.translate('Please fill in the required field(s)')
          );
        } else {
          this.utils.notify.showError(this.utils.translate('Update failed!'));
        }
        this.modalLoading = false;
      }
    );
  }

  changeExternalLink(pageTitle, pageUrl) {
    this.external = '0';
    this.pageTitle = pageTitle;
    this.currentExternalSelectUrl = pageUrl;
    this.menuForm.get('menu_link').setValue(pageTitle);
    this.urlType = false;
    this.radioDisable = false;
  }

  showEditModal(modalRef, data) {
    this.modalType = 'EDIT';
    this.menuName = data?.menu_name;
    this.menuLink = data?.menu_link;
    this.menuDesc = data?.menu_desc;
    this.menuCountry = data?.country_code;
    this.menuLanguage = data?.language_code;
    this.external = data?.external;
    this.menuType = data?.type;
    this.storeMenuId = data?.store_menu_id;
    this.visibility = +data?.visibility;
    this.currentExternalSelectUrl = data?.menu_link;
    this.radioDisable = false;

    if (+this.visibility === 1) {
      this.checked = true;
      this.unchecked = false;
    } else {
      this.unchecked = true;
      this.checked = false;
    }

    if (this.external === '0' || this.external === 0) {
      if (this.menuType === '2') {
        for (var title of this.pageList) {
          if (title.page_url === this.menuLink) {
            this.pageTitle = title.page_title;
          }
        }
        this.menuLink = this.pageTitle;
        this.radioDisable = true;

        for (var pagetitle of this.filterPageList) {
          if (pagetitle.page_title === this.menuLink) {
            this.radioDisable = false;
          }
        }
      }
      this.urlType = false;
    } else {
      this.urlType = true;
    }

    this.menuForm = this.formBuilder.group({
      menu_name: [this.menuName],
      menu_link: [this.menuLink],
      menu_desc: [this.menuDesc],
      menu_country: [this.menuCountry],
      menu_language: [this.menuLanguage],
    });
    this.modalService
      .open(modalRef, {
        size: 'md',
        centered: true,
        backdrop: 'static',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.currentSelectUrl = '';
          this.pageTitle = this.currentSelectUrl;
          this.currentExternalSelectUrl = this.currentSelectUrl;
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  menuUpdate(storeMenuId) {
    this.menuName = this.menuForm.get('menu_name').value;
    this.menuLink = this.menuForm.get('menu_link').value;
    this.menuDesc = this.menuForm.get('menu_desc').value;
    this.menuCountry = this.menuForm.get('menu_country').value;
    this.menuLanguage = this.menuForm.get('menu_language').value;
    this.modalLoading = true;

    if (this.menuLink != this.pageTitle) {
      this.external = '1';
    }

    if (this.menuType === '1') {
      this.external = '0';
      this.body = {
        store_id: this.store_id,
        store_menu_id: storeMenuId,
        menu_name: this.menuName,
        menu_desc: this.menuDesc,
        country_code: this.menuCountry,
        language_code: this.menuLanguage,
        external: this.external,
        visibility: this.visibility,
        type: this.menuType,
      };
    } else {
      if (this.external === '0') {
        if (this.menuType === '2') {
          this.menuLink = this.currentExternalSelectUrl;
          this.body = {
            store_id: this.store_id,
            store_menu_id: storeMenuId,
            menu_name: this.menuName,
            menu_link: this.menuLink,
            menu_desc: this.menuDesc,
            country_code: this.menuCountry,
            language_code: this.menuLanguage,
            external: this.external,
            visibility: this.visibility,
            type: this.menuType,
          };
        }
      } else {
        this.body = {
          store_id: this.store_id,
          store_menu_id: storeMenuId,
          menu_name: this.menuName,
          menu_link: this.menuLink,
          menu_desc: this.menuDesc,
          country_code: this.menuCountry,
          language_code: this.menuLanguage,
          external: this.external,
          visibility: this.visibility,
          type: this.menuType,
        };
      }
    }
    this.svc.putMenuUpdate(this.bearer, this.body).subscribe(
      (res) => {
        setTimeout(() => {
          this.modalLoading = false;
          this.utils.notify.showSuccess(
            this.utils.translate('Menu item has been updated!')
          );

          this.reloadMenuList();
          this.modalService.dismissAll();
        }, 3000);
      },
      (error) => {
        console.log(error);
        if (this.menuLink === '' || this.menuLink === undefined) {
          this.utils.notify.showError(
            this.utils.translate(
              'Please choose or fill in the required field(s)'
            )
          );
        } else {
          this.utils.notify.showError(this.utils.translate('Update Failed!'));
        }
        this.modalLoading = false;
      }
    );
  }

  deleteMenu(content, data) {
    this.storeMenuId = data?.store_menu_id;
    this.external = data?.external;
    this.menuType = data?.type;
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          if (result == 'delete') {
            this.loading = true;
            let body = {
              store_id: this.store_id,
              store_menu_id: this.storeMenuId,
              status: 0,
              external: this.external,
              type: this.menuType,
            };
            this.svc.putMenuUpdate(this.bearer, body).subscribe(
              (res) => {
                setTimeout(() => {
                  this.loading = false;
                  this.utils.notify.showSuccess(
                    this.utils.translate('Delete Successfully!')
                  );

                  this.reloadMenuList();
                }, 3000);
              },
              (error) => {
                console.log(error);
                this.utils.notify.showError(
                  this.utils.translate('Delete Failed!')
                );
                this.loading = false;
              }
            );
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  ngAfterViewChecked(changes) {
    // console.log('ngAfterViewChecked', changes);
  }

  ngOnChanges(changes: SimpleChanges) {
    // console.log('ngOnChanges', { changes });
  }

  ngAfterContentChecked(changes: SimpleChanges) {
    // console.log('ngAfterContentChecked', { changes });
  }

  getDisplayedMenu() {
    return this.displayedMenuList;
  }

  resetMenuArrangement(showNotification = true) {
    this.menuArrangement = this.initialArrangement;
    this.displayedMenuList = this.sortedMenuList();

    if (showNotification)
      this.utils.notify.showInfo('Arrangement has been reset');
  }

  saveMenuArrangement() {
    this.isSavingArrangement = true;
    const body = {
      store_id: this.store_id,
      arrangement: this.menuArrangement,
    };

    this.svc.updateMenuCustomArrangement(this.bearer, body).subscribe(
      (res) => {
        this.isSavingArrangement = false;
        this.saveLastArrangementListChanged(this.menuArrangement);
        this.utils.notify.showSuccess('New arrangement has been saved!');
      },
      (error) => {
        console.log(error);
        this.utils.notify.showError(error);
      }
    );
  }

  get isArrangementModified(): boolean {
    let { initialArrangement, menuArrangement } = this;
    return initialArrangement.some((v, i) => +v !== +menuArrangement[i]);
  }

  get isTileView() {
    return this.listingView === 'tile';
  }

  get isListView() {
    return this.listingView === 'list';
  }

  fetchMenuList() {
    this.loading = true;
    this.modalLoading = true;

    this.reloadMenuList();
  }

  reloadMenuList() {
    this.svc.getMenuList(this.bearer, this.store_id).subscribe((res) => {
      this.menuList = res['data'];
      this.loading = false;
      this.modalLoading = false;
      this.initialArrangement = [];
      this.menuList.forEach((element) =>
        this.initialArrangement.push(parseInt(element.store_menu_id))
      );
      this.resetMenuArrangement(false);
    }),
      (error) => {
        console.log(error);
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      };
    this.svc.getPageList(this.bearer, this.store_id).subscribe((res) => {
      let me = this;
      me.pageList = res['data'];
      me.filterPageList = me.pageList.filter((item) => +item.visibility !== 0);
      if (me.pageList.length <= 0) {
        this.externalDisplay = false;
      }
    }),
      (error) => {
        console.log(error);
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      };
  }

  generateArrangementList() {
    // console.log('Before arrange', this.menuArrangement, this.displayedMenuList);
    let menuListArrangement = Object.entries(this.displayedMenuList).map(
      (menuSort: any) => +menuSort[1].store_menu_id
    );

    this.menuArrangement = this.prepareNewArrangement(menuListArrangement);
    // console.log('After arrange', this.menuArrangement);
  }

  prepareNewArrangement(modifiedArrangement) {
    const currentArrangement = this.menuArrangement;
    const newArrangement = [];
    let replacedIndex = 0;
    currentArrangement.forEach((arrangement) => {
      if (modifiedArrangement.includes(arrangement)) {
        // Is in the filtered list
        newArrangement.push(modifiedArrangement[replacedIndex++]);
      } else {
        newArrangement.push(arrangement);
      }
    });
    return newArrangement;
  }

  saveLastArrangementListChanged(arrangementList = []) {
    console.log('Saving arrangement', arrangementList);
    console.log('Saving arrangement', this.menuList, this.displayedMenuList);
    this.initialArrangement = arrangementList;
    this.menuArrangement = arrangementList;
  }

  /*
  Drag & Drop logic
  */
  ngAfterViewInit() {
    let phElement = this.placeholder?.element?.nativeElement;
    // phElement.style.display = 'none';
    phElement?.parentElement?.removeChild(phElement);
  }

  dragMoved(e: CdkDragMove) {
    let point = this.getPointerPositionOnPage(e.event);

    this.listGroup._items.forEach((dropList) => {
      if (__isInsideDropListClientRect(dropList, point.x, point.y)) {
        let sourceId = e.source.dropContainer.id;
        let targetId = dropList.id;

        // console.log('dropList', dropList);
        this.activeContainer = dropList;
        let childrenList =
          e.source.dropContainer.element.nativeElement.parentElement.children;
        let sourceEl: any = e.source.dropContainer.element.nativeElement;
        let targetEl: any = e.source.dropContainer.element.nativeElement;

        let sourceIndex = -1;
        let targetIndex = -1;

        [...(childrenList as any)].forEach((child, index) => {
          if (child.id === sourceId) sourceIndex = index;
          if (child.id === targetId) targetIndex = index;
        });

        if (targetIndex !== sourceIndex) {
          console.log('Moving', sourceIndex, targetIndex);
          moveItemInArray(this.displayedMenuList, sourceIndex, targetIndex);
        }
        return;
      }
    });
  }

  dragStarted(e: CdkDragMove) {
    console.log('dragStarted', e);
    document.body.style.cursor = 'grabbing';
  }

  dragDropped(e: CdkDragMove) {
    console.log('dragDropped', e);
    this.generateArrangementList();
    document.body.style.cursor = 'unset';
  }

  dropListEnterPredicate = (drag: CdkDrag, drop: CdkDropList) => {
    // drag.element.nativeElement.style.backgroundColor = 'blue';

    if (drop == this.placeholder) return true;
    if (drop != this.activeContainer) return false;

    return false;
  };

  /** Determines the point of the page that was touched by the user. */
  getPointerPositionOnPage(event: MouseEvent | TouchEvent) {
    // `touches` will be empty for start/end events so we have to fall back to `changedTouches`.
    const point = __isTouchEvent(event)
      ? event.touches[0] || event.changedTouches[0]
      : event;
    const scrollPosition = this.viewportRuler.getViewportScrollPosition();

    return {
      x: point.pageX - scrollPosition.left,
      y: point.pageY - scrollPosition.top,
    };
  }

  countries;
  language_name;
  language_code;
  language;
  filteredCountry;

  coalesce(tryValue, fallbackValue) {
    return tryValue ?? fallbackValue ?? '-';
  }

  getLanguageName(language_code) {
    language_code = (language_code || 'all').toLowerCase();
    const _language = this.allLanguage?.find(
      (l) => (l.language_code || 'all').toLowerCase() === language_code
    );

    if (language_code.toLowerCase() === 'view_all') {
      return this.utils.translate('Language');
    }
    return _language?.language_name ?? language_code;
  }

  clearMenuSearch() {
    this.filteredString = '';
    this.updateFilter();
  }

  getCountryName(country_code: string) {
    if (country_code.toLowerCase() === 'view_all' || country_code === '' || !country_code) {
      return 'All Countries';
    }
    country_code = (country_code || 'all').toLowerCase();
    const country = this.allCountry?.find(
      (c) => (c.country_code || 'all').toLowerCase() === country_code
    );

    return country?.country_name ?? country_code;
  }

  getFlagByCountryCode(country_code: string) {
    country_code = (country_code || '').toLowerCase().substr(-2, 2);
    country_code = country_code === 'cm' ? 'kh' : country_code;
    return country_code;
  }

  getFlagImageURL(country_code: string) {
    console.log('item?.country_code', country_code);
    country_code = this.getFlagByCountryCode(country_code);
    return `https://cdn.estore5s.com/asset/flags/${country_code}.png`;
  }

  filterMenus(menus: any, filterString: any) {
    if (!menus || menus.length === 0) {
      return menus;
    }

    return menus
      .filter((menu: any) => {
        // Filter by search query
        const keywordsFilter = filterString[0].toLowerCase().split(' ');
        const keywordsFilterResult = keywordsFilter.every((keyword) => {
          let searchHaystack = `${menu.menu_name}`;

          return searchHaystack.toLowerCase().indexOf(keyword) >= 0;
        });

        // Filter by country
        const countryFilter = filterString[1];
        const countryFilterResult =
          countryFilter === 'VIEW_ALL' ||
          menu['country_code'] === countryFilter;

        // Filter by language
        const languageFilter = filterString[2];
        const languageFilterResult =
          languageFilter === 'VIEW_ALL' ||
          menu['language_code'] === languageFilter;

        return (
          keywordsFilterResult && countryFilterResult && languageFilterResult
        );
      })
      .sort((a, b) => {
        return a.position - b.position;
      });
  }

  changeLanguage(languageCode, languageName) {
    console.log('changeLanguage', languageCode, languageName);
    this.language_code = languageCode;
    this.language_name = languageName;
    this.updateFilter();
  }

  changeCountry(countryCode) {
    console.log('changeCountry', countryCode);
    this.filteredCountry = countryCode;

    this.updateFilter();
  }

  createFormChangeCountry(value) {
    const menu_country = this.menuForm.get('menu_country');
    console.log('createFormChangeCountry', { value, menu_country });
    menu_country.setValue(value);
  }

  createFormChangeLanguage(value) {
    const menu_language = this.menuForm.get('menu_language');
    console.log('createFormChangeLanguage', { value, menu_language });
    menu_language.setValue(value);
  }

  sortedMenuList(
    menuList = this.menuList,
    menuArrangement = this.menuArrangement
  ) {
    const sortedMenuList = [];
    menuArrangement.forEach((arrangement: any) => {
      const menuFound = menuList.find(
        (menu) => +menu.store_menu_id === +arrangement
      );
      if (menuFound) sortedMenuList.push(menuFound);
    });
    console.log(
      'Menu Sort Result',
      this.menuList,
      sortedMenuList,
      menuArrangement
    );
    return sortedMenuList;
  }

  updateFilter(event = null) {
    const filteredMenu = this.filterMenus(this.sortedMenuList(), [
      this.filteredString,
      this.filteredCountry,
      this.language_code,
    ]);
    this.displayedMenuList = filteredMenu;
    // this.generateArrangementList();
  }

  allCountry = [];
  allLanguage = [];
  fetchLanguage() {
    this.loading = true;

    this.svc.getStoreLanguage(this.bearer, this.store_id).subscribe(
      (res) => {
        let allLanguages = [];

        let enabledLanguages = [
          {
            language_code: 'VIEW_ALL',
            language_name: 'View All',
          },
          {
            language_code: 'ALL',
            language_name: 'Global',
          },
        ];

        this.allLanguage = [...enabledLanguages];

        res['data']?.forEach((lang) => {
          if (+lang.status) {
            enabledLanguages.push(lang);
          }
          this.allLanguage.push(lang);
        });

        const defaultLanguage =
          enabledLanguages.find((lang) => lang.language_code === 'VIEW_ALL') ??
          allLanguages[0];

        this.language = enabledLanguages;

        this.changeLanguage(
          defaultLanguage['language_code'],
          defaultLanguage['language_name']
        );

        this.generateArrangementList();
      },
      (error) => {
        this.loading = false;
      }
    );
  }

  fetchCountry() {
    this.svc.getStoreCountry(this.bearer, this.store_id).subscribe((res) => {
      res['data'].forEach((item) => {
        if (item['country_name'] == 'Malaysia-Brunei') {
          item['country_name'] = 'Brunei';
        }
      });
      let defaultCountry = [
        {
          country_code: 'VIEW_ALL',
          country_name: 'All Countries',
        },
        {
          country_code: 'ALL',
          country_name: 'Global',
        },
      ];

      this.countries = [...defaultCountry];
      this.allCountry = [...defaultCountry];

      this.filteredCountry = 'VIEW_ALL';
      if (res['data']) {
        res['data'].forEach((country) => {
          if (+country.status) {
            country.country_name = country.country_name.split('-').pop().trim();
            this.countries.push(country);
          }
          this.allCountry.push(country);
        });
      }
    });
  }
}
function __indexOf(collection, node) {
  return Array.prototype.indexOf.call(collection, node);
}

/** Determines whether an event is a touch event. */
function __isTouchEvent(event: MouseEvent | TouchEvent): event is TouchEvent {
  return event.type.startsWith('touch');
}

function __isInsideDropListClientRect(
  dropList: CdkDropList,
  x: number,
  y: number
) {
  const { top, bottom, left, right } =
    dropList.element.nativeElement.getBoundingClientRect();
  return y >= top && y <= bottom && x >= left && x <= right;
}
